export default ({ request }) => ({
  // Goods
  changeOrderGoodsListApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsBatchListApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/batch/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/detail',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsCopyDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/copy/detail',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsSaveApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/save',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsAddSaveApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/add/save',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsDelApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/del',
      method: 'post',
      data,
    })
  },
  // Goods-Spec
  changeGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/spec/list',
      method: 'post',
      data,
    })
  },

  changeOrderGoodsSpecProofingListApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/ProofingSpec/detail',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsSpecDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/spec/detail',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsSpecSaveApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/spec/save',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsSpecDelApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/spec/del',
      method: 'post',
      data,
    })
  },
  // Goods-Package
  // 订单产品包装选项查询
  changeOrderGoodsPackageItemSelectApi(data = {}) {
    return request({
      url: '/master/material/info/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageListApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/package/list',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageDetailApi(data = {}) {
    return request({
      url: '/factory/change/order/goods/package/detail',
      method: 'post',
      data,
    })
  },
  changeOrderGoodsPackageOrderByListApi(data = {}) {
    return request({
      url: "/factory/change/order/goods/package/orederByList",
      method: "post",
      data,
    })
  },
  changeOrderGoodsPackageSaveApi(data = {}) {
    return request({
      url: "/factory/change/order/goods/package/save",
      method: "post",
      data,
    })
  },
  changeOrderGoodsPackageDelApi(data = {}) {
    return request({
      url: "/factory/change/order/goods/package/del",
      method: "post",
      data,
    })
  },


})
